import React from 'react'
import styles from './VoteBody.scss'
import moment from 'moment'
import {FinalistCard, FinalistCardContainer} from '../FinalistCard'
import cx from 'classnames'
import {GlobalFooter} from 'common/GlobalFooter'

// prod counter:
// const DAYS_LEFT = -moment().diff('2017-05-10', 'days') + 1

const DAYS_LEFT = -moment().diff('2017-05-09', 'days') + 1

export const VoteBody = ({finalistIds, reports, votedIds, onChangeRoute, altCountdownFill}) => (
  <div className={styles.VoteBody}>
    <div className={cx(styles.countdown, altCountdownFill && styles.altFill)}>
      <div className={styles.countdownContent}>
        <div className={styles.countdownCollapse}><span>Read and cast your vote</span></div>
        <div><span className={styles.numeral}>{DAYS_LEFT}</span><span> day{DAYS_LEFT > 1 && 's'} left to vote</span></div>
      </div>
    </div>
    <div className={styles.constrainWidth}>
      <FinalistCardContainer>
        {finalistIds.map(id => reports.get(id)).filter(v => v).map(r =>
          <FinalistCard key={r.id}
            report={r}
            voted={votedIds.has(r.id)}
            onChangeRoute={onChangeRoute} />
        )}
      </FinalistCardContainer>
      <SponsorFooter />
    </div>
    <GlobalFooter />
  </div>
)

export const SponsorFooter = () => (
  <div className={styles.sponsors}>
    <p>Sponsors</p>
    <div className={styles.sponsorLogos}>
      <div><a href='https://breadwinnercycles.com/' target='_blank'><img src='/images/ride_reports_rollout/logo_breadwinner.png' /></a></div>
      <div><a href='https://sugarwheelworks.com/' target='_blank'><img src='/images/ride_reports_rollout/logo_sugar.png' /></a></div>
      <div><a href='https://ridepdw.com/' target='_blank'><img src='/images/ride_reports_rollout/logo_pdw.png' /></a></div>
    </div>
  </div>
)
